<script setup lang="ts">
/**
 * What a field or chip of the combined record shows when the selected records
 * differ on it. The values themselves are never listed.
 * Spec: docs/specs/sau-600-combined-record.md.
 *
 * `row` is accepted only so a field override, which is always handed the row,
 * does not pass it through as an HTML attribute.
 */
withDefaults(
    defineProps<{
        testId?: string;
        row?: Record<string, unknown>;
    }>(),
    { testId: 'field-multiple-values', row: undefined },
);
</script>

<template>
  <span class="text-muted-foreground" :data-testid="testId">Multiple values</span>
</template>
